import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ActorsModule = lazy(loadModule);

export default ActorsModule;
